<template>
  <div>
    <h1 class="text-3xl mb-4">Nouveau domaine</h1>

    <form
      @submit.prevent="submit"
      class="clearfix"
    >
      <input
        v-model="domain.hostname"
        placeholder="hostname"
        class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      >

      <input
        v-model="domain.banner"
        placeholder="banner"
        class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      >

      <input
        v-model="domain.color"
        placeholder="color"
        class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      >

      <!-- checkboxes -->
      <div>
        <div
          v-for="(service, index) of services"
          :key="index"
        >
          <input
            type="checkbox"
            v-model="domain.services"
            :value="service.id"
            class="mr-2"
          >

          <label>{{ service.name }}</label>
        </div>
      </div>

      <button
        type="submit"
        class="bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded text-white shadow float-right"
      >
        Nouveau domaine
      </button>

      <Error
        v-if="error"
        v-bind="error"
      />
    </form>
  </div>
</template>

<script>
import Error from '@/components/Error'

export default {
  components: {
    Error
  },

  data() {
    return {
      services: [],
      error: null,
      domain: {
        hostname: null,
        banner: null,
        color: null,
        services: []
      }
    }
  },

  async mounted() {
    try {
      const { data } = await this.$axios.get('/services')

      this.services = data
    } catch (err) {
      this.error = err.response.data
    }
  },

  methods: {
    async submit() {
      const params = {
        domain: this.domain
      }

      try {
        await this.$axios.post('/domains', params)

        this.error = null

        this.$router.push('/domaines')
      } catch (err) {
        this.error = err.response.data
      }
    }
  }
}
</script>
